import React from 'react';
import { Shield } from 'lucide-react';

interface ContagionConfigProps {
  config: {
    joursTravaillesParAn: number;
  };
  onChange: (config: { joursTravaillesParAn?: number }) => void;
}

export default function ContagionConfig({ config, onChange }: ContagionConfigProps) {
  const handleJoursChange = (joursTravaillesParAn: number) => {
    onChange({ joursTravaillesParAn });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Shield className="w-4 h-4 inline mr-1" />
          Nombre de jours travaillés par an
        </label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={config.joursTravaillesParAn}
            onChange={(e) => {
              e.stopPropagation();
              handleJoursChange(Number(e.target.value));
            }}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            min="0"
            max="365"
            step="1"
            className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <span className="text-sm text-gray-600">jours</span>
        </div>
        <div className="mt-2 text-xs text-gray-500">
          Valeur standard : 228 jours (52 semaines × 5 jours - congés)
        </div>
      </div>
    </div>
  );
}